export const customEmailConstants = {

    // REQUEST_SEND_REMAINDER
    REQUEST_SEND_REMAINDER: 'REQUEST_SEND_REMAINDER',
    RECIEVE_SEND_REMAINDER: 'RECIEVE_SEND_REMAINDER',
    ERROR_SEND_REMAINDER: 'ERROR_SEND_REMAINDER',

    // REQUEST_CUSTOM_MAIL
    REQUEST_CUSTOM_MAIL:'REQUEST_CUSTOM_MAIL',
    RECIEVE_CUSTOM_MAIL:'RECIEVE_CUSTOM_MAIL',
    ERROR_CUSTOM_MAIL:'ERROR_CUSTOM_MAIL',
    
};



// WEBPACK FOOTER //
// ./src/_constants/customEmails.constants.js